<template>
    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
        <template v-slot:button-content>
            <i class="fa-star text-warning cursor-pointer" :class="featuredClass"/>
            <i class="fas fa-th-large text-warning" v-b-tooltip title="In Customer Grid" v-if="customerGrid"></i>
            <i class="fas fa-stream text-warning" v-b-tooltip title="In Customer Carousel" v-if="customerCarousel"></i>
        </template>

        <b-dropdown-item @click="toggleFeatured">
            <span v-if="!featured" class="text-primary">Set Featured</span>
            <span v-else class="text-danger">Remove Featured</span>
        </b-dropdown-item>

        <b-dropdown-item v-if="featured" @click="toggleCustomerCarousel">
            <span v-if="!customerCarousel">Add to <b>Customer Carousel</b></span>
            <span v-else class="text-danger">Remove from <b>Customer Carousel</b></span>
        </b-dropdown-item>

        <b-dropdown-item v-if="featured" @click="toggleCustomerGrid">
            <span v-if="!customerGrid">Add to <b>Customer Grid</b></span>
            <span v-else class="text-danger">Remove from <b>Customer Grid</b></span>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
  import GeneralMixins from "../../../mixins/GeneralMixins";
  import normalize from "json-api-normalize";
  import Attributes from "../../../models/Attributes";

  export default {

    props: ['featuredAsset', 'url', 'assetId'],

    mixins: [GeneralMixins],

    data() {
      return {
        featured: null,
        featuredId: null,
        customerGrid: null,
        customerCarousel: null,
      }
    },

    created() {
      this.updateLocalFeatured(this.featuredAsset);
    },

    methods: {
      toggleFeatured() {
        if (this.featured) {
          this.removeFeatured();
        } else {
          this.createFeatured();
        }
      },

      toggleCustomerGrid() {
        this.customerGrid = !this.customerGrid;
        this.createFeatured();
      },

      toggleCustomerCarousel() {
        this.customerCarousel = !this.customerCarousel;
        this.createFeatured();
      },

      removeFeatured() {
        this.$http.delete(`${this.url}/${this.featuredId}`).then(fulfilled => {
          this.updateLocalFeatured({})
        }, rejected => {
          this.showErrorToast("Sorry, there was an error. Please try again later");
        });
      },

      createFeatured() {
        this.$http.post(this.url, {
          featured_asset: {
            asset_id: this.assetId,
            customer_grid: this.customerGrid,
            customer_carousel: this.customerCarousel
          }
        }).then(fulfilled => {
          this.updateLocalFeatured(normalize(fulfilled.body).get(Attributes.featuredAssetAttributes));
        })
      },

      updateLocalFeatured(featuredAsset) {
        this.featured = featuredAsset.id !== null && featuredAsset.id !== undefined;
        this.featuredId = featuredAsset.id;
        this.customerGrid = featuredAsset.customer_grid || false;
        this.customerCarousel = featuredAsset.customer_carousel || false;
      }
    },

    computed: {
      featuredClass() {
        return this.featured ? 'fas' : 'far';
      }
    }
  }
</script>